"use strict";
var carbucks = carbucks || {};
const partnerSliders = document.getElementsByClassName("js-partner-slider");
carbucks.partners =
  carbucks.partners ||
  (function() {
    function init() {
      if (partnerSliders) {
        for (let i = 0; i < partnerSliders.length; i++) {
          const currentSlider = partnerSliders[i];

          var flkty = new Flickity(currentSlider, {
            // options
            cellAlign: "left",
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: true,
            cellSelector: ".js-item-partner",
          });
        }
      }
    }
    return {
      init: init,
    };
  })();
